import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ServiceCarouselItem, ServiceItemCarouselItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { NavigationButtonComponent, SdvorSwiperComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2/models';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { SwiperOptions } from 'swiper/types';
import { ServiceCarouselItemComponent } from './service-carousel-item';

@Component({
  selector: 'sd-service-carousel',
  imports: [
    AsyncPipe,
    SdvorSwiperComponent,
    ServiceCarouselItemComponent,
    RouterLink,
    NavigationButtonComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './service-carousel.component.html',
  styleUrls: ['./service-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCarouselComponent implements OnInit {
  iconTypes = IconTypes;

  config: SwiperOptions = {
    slidesPerView: 6,
    spaceBetween: 16,
    scrollbar: { enabled: false },
    navigation: { enabled: true },
  };

  isTabletMdUp$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktopLgUp$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  serviceCarousel$: Observable<ServiceCarouselItem | undefined>;

  get allServices$(): Observable<('allServices' | ServiceItemCarouselItem)[]> {
    return this.serviceCarousel$.pipe(
      map((serviceCarousel) => (serviceCarousel?.items.length ? this.getAllServices(serviceCarousel.items) : [])),
    );
  }

  constructor(
    public deviceService: DeviceService,
    private promoService: PromoService,
  ) {}

  ngOnInit(): void {
    const isSdvorApp = this.deviceService.isSdvorApp();

    this.serviceCarousel$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTabletMdUp: this.isTabletMdUp$,
      isDesktopLgUp: this.isDesktopLgUp$,
    }).pipe(
      map(({ promo, isTabletMdUp, isDesktopLgUp }) => {
        if (promo.serviceCarousel) {
          let { items } = promo.serviceCarousel;

          // TODO: костыль для HP-55
          if (isSdvorApp) {
            items = items.filter((item) => item.link.toLowerCase() !== '/prilozhenie-stroitelnyj-dvor');
          }

          return {
            ...promo.serviceCarousel,
            items: items.map((item) => ({
              ...item,
              url: isDesktopLgUp ? item.url.isDesktop : isTabletMdUp ? item.url.isTablet : item.url.isMobile,
            })),
          };
        }

        return undefined;
      }),
    );
  }

  getAllServices(items: ServiceItemCarouselItem[]): ('allServices' | ServiceItemCarouselItem)[] {
    return ['allServices', ...items];
  }
}
